"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchFilterCloseButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const crossColor = "rgb(102, 102, 102)";
exports.ManagerSearchFilterCloseButton = styled_components_1.default.span `
  display: block;
  position: absolute;
  right: 2%;
  top: 2%;
  cursor: pointer;

  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  opacity: 0.8;

  &:before,
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    background: ${crossColor};
  }

  &:before {
    left: 55%;
    width: 20%;
    margin-left: -15%;
    height: 100%;
  }

  &:after {
    top: 55%;
    height: 20%;
    margin-top: -15%;
    width: 100%;
  }

  &:hover {
    opacity: 1;
  }
`;
//# sourceMappingURL=search-filter-close-button.js.map